import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../Navbar";
import Footer from "../Footer";
import ErrorBoundary from "../../ErrorBoundary";
import "./index.css";

const MainLayout: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <div className="app-container">
      <Navbar />
      <main className="main-content">
        <ErrorBoundary resetKey={pathname}>
          <Outlet />
        </ErrorBoundary>
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
